import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { calculatePricingPlans } from "@/utils/pricing";
import { CoachDetailsCard } from "@/components/payment/CoachDetailsCard";
import { PaymentForm } from "@/components/payment/PaymentForm";
import { PerksCard } from "@/components/payment/PerksCard";

export const Payment = () => {
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  const selectedCoach = JSON.parse(localStorage.getItem('selectedCoach') || '{}');

  // PLANS: useMemo kullanarak planların her render'da değişmesini engelliyoruz.
  // Bu, PricingTabs'in stabil çalışması için çok kritik.
  const plans = useMemo(() => {
    return calculatePricingPlans(
      selectedCoach.monthly_price || 0,
      selectedCoach.per_month_extend_discount || 0
    );
  }, [selectedCoach.monthly_price, selectedCoach.per_month_extend_discount]);

  // INITIAL STATE: Seçili planı başlat
  const [selectedPlan, setSelectedPlan] = useState(() => {
    if (selectedCoach.selectedPlan?.totalPrice) {
      return selectedCoach.selectedPlan;
    }
    return plans && plans.length > 0 ? plans[0] : null;
  });

  // GÜVENLİK KONTROLÜ: Veri yoksa geri at
  useEffect(() => {
    if (!userDetails.email || !selectedCoach.id) {
      navigate('/coaches');
    }
  }, [userDetails, selectedCoach, navigate]);

  return (
    // ARKA PLAN: Modern Indigo/Slate Gradyanı ve Beyaz Yazı Teması
    <div className="min-h-screen bg-gradient-to-br from-[#4F46E5] via-[#3730A3] to-[#1E293B] p-4 pt-24 text-white">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-8 items-start">

          {/* Sol Kolon: Koç Bilgileri */}
          <div className="space-y-6">
            <CoachDetailsCard coach={selectedCoach} />
            <PerksCard />
          </div>

          {/* Sağ Kolon: Ödeme Formu */}
          <div className="relative">
            {/* Dekoratif bir parıltı efekti */}
            <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl blur opacity-20"></div>

            <PaymentForm
              userName={userDetails.nameSurname?.split(' ')[0]}
              userDetails={userDetails}
              selectedCoach={selectedCoach}
              plans={plans}
              selectedPlan={selectedPlan}
              onSelectPlan={setSelectedPlan}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Payment;